import axios from "./axios"

const createUpdateReview = async (data, id) => {
	if (id) {
		return await axios.put(`/review/${id}`, data).then((data) => {
			return data
		})
	} else {
		return await axios.post(`/review`, data).then((data) => {
			return data
		})
	}
}

const getReviewList = async (data) => {
	return await axios.get(`/review/user`, data).then((data) => {
		return data
	})
}

const getAllReviewList = async () => {
	return await axios.get(`/review/user`).then((data) => {
		return data
	})
}

const getReview = async (data) => {
	return await axios.get(`/review/${data?.id}${data?.is_case_admin ? `?is_case_admin=true` : ``}`).then((data) => {
		return data
	})
}

const getReviewBasedOnFileId = async (id) => {
	return await axios.get(`review/file/${id}`).then((data) => {
		return data
	})
}

const updateReviewStatus = async ({ reviewId, reviewFileId, status }) => {
	return await axios
		.put(`/review/reviewed?review_id=${reviewId}&review_file_id=${reviewFileId}`, {
			is_reviewed: status,
		})
		.then((data) => {
			return data
		})
}

const getReviewSearch = async (param, data) => {
	const url = `/review/search/${param.review_id}${param?.is_case_admin ? `?is_case_admin=${param.is_case_admin}` : ``}`
	return await axios.post(url, data).then((data) => {
		return data
	})
}

export const reviewService = {
	createUpdateReview,
	getReviewList,
	getReview,
	updateReviewStatus,
	getReviewBasedOnFileId,
	getAllReviewList,
	getReviewSearch,
}
